// src/contexts/AppConfigContext.js
import React, { createContext, useState, useContext } from 'react';

const AppConfigContext = createContext();

export const useAppConfig = () => {
  return useContext(AppConfigContext);
};

export const AppConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    requiredLevelKey: 'level',
    requiredTimeKey: 'time',
  });

  const value = {
    config,
    setConfig,
  };

  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  );
};
